module.exports = __webpack_public_path__ + "static/img/top.6db35da1.png";